import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, UserX, ShieldAlert, BrainCircuit } from 'lucide-react';
interface InvestorSlide2Props {
  isDark?: boolean;
}
export function InvestorSlide2({
  isDark = false
}: InvestorSlide2Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  const problems = [{
    icon: AlertTriangle,
    title: 'Silent Burnout',
    description: 'Leaders are burning out in silence, fearing professional repercussions.',
    color: 'orange'
  }, {
    icon: ShieldAlert,
    title: 'Professional Stigma',
    description: 'Deep-rooted stigma prevents leaders from seeking help early.',
    color: 'red'
  }, {
    icon: UserX,
    title: 'EAP Failure',
    description: 'Traditional EAPs serve <5% of the workforce and miss leaders entirely.',
    color: 'slate'
  }, {
    icon: BrainCircuit,
    title: 'Design Gap',
    description: "Existing tools aren't designed for leadership-specific challenges.",
    color: 'navy'
  }];
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-234">
      <div className="min-h-full flex flex-col justify-center max-w-6xl mx-auto px-6 sm:px-12 py-20 sm:py-24" data-id="element-235">
        <motion.div variants={itemVariants} className="mb-12 sm:mb-16 text-center" data-id="element-236">
          <h1 className={`text-3xl sm:text-5xl font-bold mb-6 sm:mb-8 tracking-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-237">
            The Problem
          </h1>
          <p className={`text-lg sm:text-2xl max-w-3xl mx-auto ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-238">
            Leadership health is the single biggest unaddressed risk in modern
            organizations.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8" data-id="element-239">
          {problems.map((problem, idx) => {
          const Icon = problem.icon;
          return <motion.div key={idx} variants={itemVariants} className={`flex items-start gap-5 p-6 sm:p-8 rounded-2xl transition-all ${isDark ? 'bg-white/[0.03] border border-white/10 hover:bg-white/[0.05]' : 'bg-white border border-heliona-beige hover:shadow-md'}`} data-id="element-240">
                <div className={`p-3 rounded-xl flex-shrink-0 ${isDark ? 'bg-white/10' : `bg-heliona-${problem.color}/10`}`} data-id="element-241">
                  <Icon className={`w-6 h-6 sm:w-8 sm:h-8 ${isDark ? 'text-white' : `text-heliona-${problem.color === 'red' ? 'orange' : problem.color}`}`} data-id="element-242" />
                </div>
                <div data-id="element-243">
                  <h3 className={`text-lg sm:text-xl font-bold mb-2 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-244">
                    {problem.title}
                  </h3>
                  <p className={`text-sm sm:text-base leading-relaxed ${isDark ? 'text-white/70' : 'text-heliona-text-gray'}`} data-id="element-245">
                    {problem.description}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </motion.div>;
}